import React from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Glyphicon } from '@bingads-webui-react/primitive';
import { withSiteMap, getRoutePathById } from '@bingads-webui-campaign-react/with-site-map';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { withI18nConsumer } from '@bingads-webui-react/i18n-context';
import { QueryParam, withScope } from '@bingads-webui-react/scope-service';
import { Callout } from '@bingads-webui-react/callout';
import { StyledMenuItemTag } from '@bingads-webui-react/menu-item-tag';

import { getAutoApplyItemButtonStyles } from '../styles/auto-apply-button-styles';

function autoApplyClickHandler(siteMap, scope) {
  scope.save(getRoutePathById(
    siteMap,
    'recommendation-auto-apply-settings'
  ));
}

class autoApplyButton extends React.Component {
  state = { showPopover: false };

  toggle = () => {
    this.setState(state => ({ showPopover: !state.showPopover }));
  }

  render() {
    const showTag = {
      text: _TL_('BETA'),
      expDate: new Date('2023/03/31'),
    };
    const {
      i18n, scope, siteMap, classes,
    } = this.props;

    return (
      <div className={classNames([
        'recommendation-auto-apply-item',
        classes.recommendationAutoApplyItem,
        ])}
      >
        <Callout
          popoverId="recommendation-auto-apply-popover"
          popoverClassName={classes.recommendationAutoApplyPopover}
          show={this.state.showPopover}
          onClose={this.toggle}
          content={
            <span className={classes.entityContent}>{i18n.getString(_TL_('Auto-apply setting'))}</span>
          }
          placement="bottom"
          closeButton={false}
        >
          <button
            onClick={() => autoApplyClickHandler(siteMap, scope)}
            onFocus={this.toggle}
            onBlur={this.toggle}
            onMouseOver={this.toggle}
            onMouseOut={this.toggle}
            className={classes.entityContentRecommendationAutoApply}
            aria-label={i18n.getString(_TL_('Auto-apply setting'))}
          >
            <Glyphicon
              className={classes.entityIcon}
              glyph="ba-FlashAuto"
            />
          </button>
        </Callout>
        <div className={classes.betaTagContainer}>
          <StyledMenuItemTag i18n={i18n} tagContent={showTag} tagClass="blueTag" />
        </div>
      </div>
    );
  }
}

autoApplyButton.propTypes = {
  classes: PropTypes.shape(_.mapObject(
    getAutoApplyItemButtonStyles({}, {}),
    _.constant(PropTypes.string.isRequired)
  )).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  scope: PropTypes.instanceOf(QueryParam).isRequired,
  siteMap: PropTypes.arrayOf(PropTypes.any).isRequired,
};

const AutoApplyButton = withI18nConsumer(withSiteMap(withScope(withDefaultStyles(autoApplyButton, getAutoApplyItemButtonStyles))));

export {
  AutoApplyButton,
};
